/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_No_Segments_ToastInputs */



/**
* | output |
* | --- |
* | "Unable to segment Event Group. Please insert segments." |
*
* @param {Segment_Event_Group_No_Segments_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_no_segments_toast = /** @type {((inputs?: Segment_Event_Group_No_Segments_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_No_Segments_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de segmenter le groupe d'evenements. Veuillez inserer des segments.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisgruppe konnte nicht segmentiert werden. Bitte fügen Sie Segmente ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile segmentare il gruppo di eventi. Inserire i segmenti.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось выделить группу событий. Пожалуйста, добавьте сегменты.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede segmentar el grupo de eventos. Inserte segmentos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法对事件组进行分段。请插入分段。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループをセグメント化できません。セグメントを挿入してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप को सेगमेंट करने में असमर्थ। कृपया सेगमेंट डालें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível segmentar o Grupo de Eventos. Insira os segmentos.")
	return /** @type {LocalizedString} */ ("Unable to segment Event Group. Please insert segments.")
});